const RECAP_SHARE_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/
const RECAP_TEMPLATE_ID_PATTERN = /^[A-Z0-9_]{1,64}$/
const RECAP_SOURCE_GAME_ID_PATTERN = /^[A-Z0-9_-]{1,64}$/

const RECAP_VARIATIONS = ['print', 'tv', 'polaroids', 'reel', 'single_image'] as const

const normalizeString = (value: unknown): string | undefined => {
    if (typeof value !== 'string') return undefined
    const normalized = value.trim()
    return normalized.length > 0 ? normalized : undefined
}

export const normalizeRecapShareId = (value: unknown): string | undefined => {
    const normalized = normalizeString(value)
    if (!normalized || !RECAP_SHARE_ID_PATTERN.test(normalized)) return undefined
    return normalized
}

export const normalizeRecapTemplateId = (value: unknown): string | undefined => {
    const normalized = normalizeString(value)?.toUpperCase()
    if (!normalized || !RECAP_TEMPLATE_ID_PATTERN.test(normalized)) return undefined
    return normalized
}

export const normalizeRecapSourceGameId = (value: unknown): string | undefined => {
    const normalized = normalizeString(value)?.toUpperCase()
    if (!normalized || !RECAP_SOURCE_GAME_ID_PATTERN.test(normalized)) return undefined
    return normalized
}

export const normalizeRecapVariation = (value: unknown): typeof RECAP_VARIATIONS[number] | undefined => {
    const normalized = normalizeString(value)?.toLowerCase()
    if (!normalized) return undefined
    return RECAP_VARIATIONS.find((variation) => variation === normalized)
}

export const buildRecapShareUrl = (
    siteUrl: string,
    options: {
        shareId: unknown
        templateId?: unknown
        sourceGameId?: unknown
        variation?: unknown
    }
): string | null => {
    const shareId = normalizeRecapShareId(options.shareId)
    if (!shareId) return null

    const url = new URL(`/r/${encodeURIComponent(shareId)}`, siteUrl)
    const templateId = normalizeRecapTemplateId(options.templateId)
    const sourceGameId = normalizeRecapSourceGameId(options.sourceGameId)
    const variation = normalizeRecapVariation(options.variation)

    if (templateId) url.searchParams.set('template', templateId)
    if (sourceGameId) url.searchParams.set('sourceGame', sourceGameId)
    if (variation) url.searchParams.set('variation', variation)

    return url.toString()
}
